var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrzeglad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216.68 130.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .d {\r\n        fill: #fff;\r\n      }\r\n\r\n      .e {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .e, .f {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-width: 7.93px;\r\n      }\r\n\r\n      .f {\r\n        stroke-linejoin: round;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 80.48,
    y1: 114.66,
    x2: 147.46,
    y2: 115.49
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 25.38,
    cy: 12.31,
    r: 12.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M57.81,67.91L37.32,28.12h-10.95l-4.58,16.84-4.58-16.84H6.46c-4.55,0-6.46,3.58-6.46,6.68v41.41H6.46v53.12h13.91l1.43-48.14,1.43,48.14h14.11V46.63l14.19,28.79,6.3-7.52Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 56.88,
    y1: 75.42,
    x2: 159.39,
    y2: 81.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 64.67,
    cy: 111.98,
    r: 14.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 172.72,
    cy: 111.98,
    r: 14.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M44.11,75.42h12.77l15.99-22.36c4.12-4.12,9.71-6.44,15.54-6.44h46.7c5.5,0,10.79,2.1,14.78,5.88l22.83,21.58,35.78,11.93,4.21,15.44v14.03h-15.32"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrzeglad);
export default __webpack_public_path__ + "static/media/przeglad.5a489203e15199783549607118f13e9d.svg";
export { ForwardRef as ReactComponent };